import wrapInObserver from '../wrapInObserver';
import Rating from './Rating';

import generatedHooks from '../../hooks/generatedHooks';
import logger from '../../logger';
import ratingViewTypes from '../../constants/ratingViewTypes';
import { rowCountDefault } from '../../constants/skeletonDefaults';
import BannerStore from '../../stores/bannerStore';

const {
  useRatingStore,
  useUiStore,
  useRootStore,
  useGeoStore,
  useBannerStore,
} = generatedHooks;

const mapProps = () => {
  try {
    const {
      firms,
      totalFirmsCount,
      isLoading,
    } = useRatingStore(store => store);

    const {
      pageSize,
      selectedRow,
      resetFilterToDefaults,
      isMobile,
    } = useUiStore(store => store);

    const { reload } = useRootStore(store => store);
    const { resetStore } = useGeoStore(store => store);
    const { shouldShowBanner } = useBannerStore(store => store);

    const rowsCount = firms && firms.length > 0 ? firms.length : rowCountDefault;
    const showPaging = totalFirmsCount > pageSize;

    let ratingStateType = ratingViewTypes.Found;
    if (isLoading) {
      ratingStateType = ratingViewTypes.IsLoading;
    } else if (!firms || firms.length === 0) {
      ratingStateType = ratingViewTypes.NotFound;
    }

    const isRatingLoading = ratingStateType === ratingViewTypes.IsLoading;
    const isFound = ratingStateType === ratingViewTypes.Found;
    const isNotFound = ratingStateType === ratingViewTypes.NotFound;

    const resetFilterAction = () => {
      resetFilterToDefaults();
      resetStore();
      reload();
    };

    return {
      firms,
      totalFirmsCount,
      rowsCount,
      selectedRow,
      showPaging,
      isFound,
      isNotFound,
      isRatingLoading,
      resetFilterAction,
      showActiveTransporterBanner: shouldShowBanner(BannerStore.BANNER_TYPES.TRANSPORTER),
      showSafetyBanner: shouldShowBanner(BannerStore.BANNER_TYPES.SAFETY),
      showReadyForEtrnBanner: shouldShowBanner(BannerStore.BANNER_TYPES.ETRN),
      showAvgPriceBanner: shouldShowBanner(BannerStore.BANNER_TYPES.AVG_PRICE),
      isMobile,
    };
  } catch (error) {
    logger.error(error);
    return {};
  }
};

export default wrapInObserver(Rating, mapProps);
